import { React, useContext } from "react";
import { Navigate } from "react-router-dom";

import AuthContext from "../common/AuthContext";

// eslint-disable-next-line react/prop-types
const ProtectedRoute = ({ children, accessBy }) => {
  const { user, checkIsAuthenticated, isTokenExpired } =
    useContext(AuthContext);

  if (accessBy === "non-authenticated") {
    return children;
  } else if (accessBy === "authenticated") {
    if (user && checkIsAuthenticated()) {
      return children;
    }
  }
  return <Navigate to="/login" />;
};

export default ProtectedRoute;
